function asText(value: unknown): string {
  return typeof value === 'string' ? value.trim() : '';
}

function emailLocalPart(value: unknown): string {
  const email = asText(value);
  if (!email) return '';
  const local = email.split('@')[0];
  return local ? local.trim() : '';
}

export type ClientDisplayIdentity = {
  businessName?: unknown;
  firstName?: unknown;
  lastName?: unknown;
  displayName?: unknown;
  name?: unknown;
  email?: unknown;
  uid?: unknown;
  id?: unknown;
};

export function resolveClientDisplayName(
  identity: ClientDisplayIdentity,
  fallback = 'Client',
): string {
  const businessName = asText(identity.businessName);
  if (businessName) return businessName;

  const firstName = asText(identity.firstName);
  const lastName = asText(identity.lastName);
  const combinedName = [firstName, lastName].filter(Boolean).join(' ').trim();
  if (combinedName) return combinedName;

  const displayName = asText(identity.displayName) || asText(identity.name);
  if (displayName) return displayName;

  const emailLocal = emailLocalPart(identity.email);
  if (emailLocal) return emailLocal;

  const uid = asText(identity.uid) || asText(identity.id);
  if (uid) return uid;

  return fallback;
}

export function resolveClientDisplayNameFromTicket(
  ticket: unknown,
  fallback = 'Client',
): string {
  const record =
    ticket && typeof ticket === 'object'
      ? (ticket as Record<string, unknown>)
      : {};
  return resolveClientDisplayName(
    {
      businessName: record.clientBusinessName ?? record.businessName,
      firstName: record.clientFirstName ?? record.firstName,
      lastName: record.clientLastName ?? record.lastName,
      displayName:
        record.clientDisplayName ??
        record.clientName ??
        record.displayName ??
        record.name,
      email: record.clientEmail ?? record.email,
      uid: record.clientId ?? record.uid ?? record.id,
      id: record.id,
    },
    fallback,
  );
}
